import { EventBus } from './EventBus';

export const AppVisibilityBus = new EventBus('app-visibility-bus');
